import { useFormikContext } from "formik";
import React, { useEffect, useMemo, useRef } from "react";
import Dropdown from "./Dropdown";

const ProvinceField = ({ countryLookup, ...props }) => {
  const {
    values: { country_code, province_code },
    setFieldValue,
  } = useFormikContext();
  const previousCountry = useRef(country_code);

  const provinces = useMemo(() => {
    if (
      !country_code ||
      !countryLookup[country_code] ||
      !countryLookup[country_code].provinces
    ) {
      return null;
    }

    return countryLookup[country_code].provinces.map((province) => ({
      label: province.name,
      value: province.code,
    }));
  }, [countryLookup, country_code]);

  // Clear the province when the country actually changes — not on mount, which
  // used to wipe a province restored from a saved address.
  useEffect(() => {
    if (previousCountry.current === country_code) {
      return;
    }

    previousCountry.current = country_code;
    setFieldValue("province_code", "");
  }, [setFieldValue, country_code]);

  // A province that isn't valid for the selected country can't stay selected.
  useEffect(() => {
    if (!provinces || !province_code) {
      return;
    }

    if (!provinces.some(({ value }) => value === province_code)) {
      setFieldValue("province_code", "");
    }
  }, [provinces, province_code, setFieldValue]);

  if (!provinces) {
    return null;
  }

  return (
    <Dropdown options={provinces} placeholder="Select a province" {...props} />
  );
};

export default ProvinceField;
